import React from 'react';
import {BASE_URL} from './index';

const SITE_NAME = "Farmer's Fresh Meat";

// Builds the JSON-LD <script> tag for use directly inside <Helmet>. JSON.stringify keeps quotes in
// content from breaking the markup; "<" is escaped so the payload can't close the script tag.
export function jsonLdScript(data) {
    const json = JSON.stringify(data).replace(/</g, '\\u003c');
    return React.createElement('script', {type: 'application/ld+json'}, json);
}

// Schema for a single page: the page itself, linked to the site-wide Organization and WebSite.
// Use `extra` to add type-specific fields (e.g. headline/datePublished for a BlogPosting).
export function pageSchema({type = 'WebPage', name, pathname, description, extra = {}}) {
    const base = BASE_URL();
    const url = base + pathname;
    return {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "@id": base + "/#organization",
                "name": SITE_NAME,
                "url": base + "/"
            },
            {
                "@type": "WebSite",
                "@id": base + "/#website",
                "url": base + "/",
                "name": SITE_NAME,
                "publisher": {"@id": base + "/#organization"},
                "inLanguage": "en-US"
            },
            {
                "@type": type,
                "@id": url + "#webpage",
                "url": url,
                "name": name,
                ...(description ? {"description": description} : {}),
                "isPartOf": {"@id": base + "/#website"},
                "inLanguage": "en-US",
                ...extra
            }
        ]
    };
}
